import {i18n} from '@/plugins/i18n'
import BankColumn from "../bank-column";


const bankTemplate = (row, index, datatable) => {
    let template = new BankColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}
export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 70,
        type: 'number',
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
    },
    {
        field: 'payer_name',
        title: i18n.t('deposit.payer_name'),
        sortable: true,
        width: 120,
        type: 'number',
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
    },
    {
        field: 'gateway_title',
        title: i18n.t('label.gateway_title'),
        sortable: false,
        template: (row) => {
            return '<a href="/open-banking/deposit/starshop/update/' + row.gateway_id + '">' + row.gateway_title + '</a>'
        },
        textAlign: 'center'
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: false,
        textAlign: 'center',
        width: 90
    },
]